import { keyframes, css } from 'styled-components';
export function getModalSize(modalSize) {
    switch (modalSize) {
        case 'FitToContent':
            return '';
        case 'Large':
            return css `
        width: 1140px;
        max-width: 100%;
      `;
        case 'Medium':
            return css `
        width: 720px;
        max-width: 100%;
      `;
        case 'Small':
            return css `
        width: 540px;
        max-width: 100%;
      `;
        default:
            return '';
    }
}
export const animationSpeed = {
    Slow: 500,
    Medium: 333,
    Fast: 200,
    Instant: 0,
    default: 333,
    getSpeed(speed) {
        switch (speed) {
            case 'Slow':
                return this.Slow;
            case 'Medium':
                return this.Medium;
            case 'Fast':
                return this.Fast;
            case 'Instant':
                return this.Instant;
            default:
                return this.default;
        }
    }
};
export function getAnimationFrom(animation, transitionType, transitionSpeed) {
    switch (transitionType) {
        case 'FadeIn FadeOut':
            return css `
        opacity: ${animation === 'in' ? 1 : 0};
        animation: ${animation === 'in' ? fadeIn : fadeOut}
          ${animationSpeed.getSpeed(transitionSpeed)}ms ease-out;
      `;
        case 'SlideDown FadeOut':
            return css `
        transform: translate3d(0, 0, 0);
        opacity: ${animation === 'in' ? 1 : 0};
        animation: ${animation === 'in' ? slideDown : fadeOut}
          ${animationSpeed.getSpeed(transitionSpeed)}ms ease-out;
      `;
        case 'SlideDown SlideBelow':
            return css `
        transform: ${animation === 'in'
                ? 'translate3d(0, 0, 0)'
                : 'translate3d(0, 25%, 0)'};
        animation: ${animation === 'in' ? slideDown : slideBelow}
          ${animationSpeed.getSpeed(transitionSpeed)}ms ease-out;
      `;
        case 'SlideDown InstantRemove':
            return css `
        transform: translate3d(0, 0, 0);
        opacity: ${animation === 'in' ? 1 : 0};
        animation: ${animation === 'in' ? slideDown : fadeOut}
          ${animationSpeed.getSpeed(animation === 'in' ? transitionSpeed : 'Instant')}ms
          ease-out;
      `;
        case 'ScaleUp ScaleDown':
            return css `
        transform: ${animation === 'in' ? 'scale(1)' : 'scale(0)'};
        animation: ${animation === 'in' ? scaleUp : scaleDown}
          ${animationSpeed.getSpeed(transitionSpeed)}ms ease-out;
      `;
        default:
            return '';
    }
}
export const fadeIn = keyframes `
  from {
    opacity: 0;
  }
  to: {
    opacity: 1;
  }
`;
export const fadeOut = keyframes `
  from {
    opacity: 1;
  }
  to: {
    opacity: 0;
  }
`;
export const slideDown = keyframes `
  from {
    transform: translate3d(0, -25%, 0);
  }
  to: {
    transform: translate3d(0, 0, 0);
  }
`;
export const slideBelow = keyframes `
  from {
    transform: translate3d(0, 0, 0);
  }
  to: {
    transform: translate3d(0, -25%, 0);
  }
`;
export const scaleUp = keyframes `
  from {
    transform: scale(0);
  }
  to: {
    transform: scale(1);
  }
`;
export const scaleDown = keyframes `
  from {
    transform: scale(1);
  }
  to: {
    transform: scale(0);
  }
`;
//# sourceMappingURL=animations.js.map